(ns frontend.ui.component.lp-portal.report.company.enterprise-value-chart.controller
  (:require
    [frontend.ui.component.chart.utils :as chart-utils]
    [frontend.ui.page.lp-portal.report.util :as util]
    [frontend.ui.style.theme.core :as theme]
    [frontend.utils :as fu]))


(defn config->editable-data
  [config]
  (let [data (->> config
                  :series
                  (first)
                  :data)
        axis (->> config
                  :yAxis)]
    {:columns       (->> data
                         (mapv (fn [serie]
                                 (:name serie))))
     :data          [(vec (concat ["Values"]
                                  (->> data
                                       (map :y))))]
     :series-colors (->> data
                         (mapv (fn [serie]
                                 (:color serie))))
     :y-axis-config (chart-utils/config->editable-y-axis-data config)}))

(defn editable-data->raw-data
  [edited-data]
  (let [columns (:columns edited-data)
        data (->> edited-data
                  :data
                  (first)
                  (filter (fn [v]
                            (not= v "Values")))
                  (mapv (fn [v]
                          (when (number? v) v))))
        colors (:series-colors edited-data)]
    {:labels     columns
     :value      data
     :color-code colors}))

(defn chart-config
  [data]
  (let [dt (->>
             (mapv (fn [label value color-code]
                     (when (number? value)
                       {:name  label
                        :y     value
                        :color color-code}))
                   (:labels data)
                   (:value data)
                   (:color-code data))
             (doall))
        y-axis-1 (chart-utils/resolve-editable-axis-data (first (:y-axis-config data)) chart-utils/axis-meur-formatter-no-division "")]
    {:chart       {:type "waterfall"}
     :tooltip     {:outside         true
                   :useHtml         true
                   :backgroundColor (theme/color [:page-bg :bg])
                   :style           {:opacity         1
                                     :backgroundColor (theme/color [:page-bg :bg])}
                   :enabled         false}
     :plotOptions {:series    {:colorByPoint true
                               :borderWidth  0
                               :dataLabels   {:enabled   true
                                              :inside    false
                                              ;:verticalAlign "top"
                                              :style     {:color       "contrast"
                                                          :textOutline false}
                                              :formatter (fn [arg]
                                                           (this-as
                                                            js-data-point
                                                            (let [point (js->clj js-data-point
                                                                                 :keywordize-keys
                                                                                 true)]
                                                              (str (util/->float-1-decimals
                                                                    (fu/absolute-float (:y
                                                                                        point)))))))
                                             }}
                   :waterfall {}}
     :legend      {:enabled false}
     :xAxis       {:type          "category"
                   ;:categories    (map :name dt)
                   :lineColor     (theme/color [:chart :x-axis :line])
                   :gridLineColor (theme/color [:chart :x-axis :grid-line])}
     :yAxis       [{:visible       true
                   :title         {:text (:title-text y-axis-1)}
                   :labels        {:formatter     (:formatter-fn y-axis-1)}
                   :softMin       (let [min-sum (->> [(first dt)
                                                      (last dt)]
                                                     (map :y)
                                                     (filter number?)
                                                     (apply min))
                                        max-change (->> dt
                                                        (rest)
                                                        (butlast)
                                                        (map :y)
                                                        (filter number?)
                                                        (map (fn [n]
                                                               (if (neg? n)
                                                                 (- n)
                                                                 n)))
                                                        (apply max))]
                                    (if (and (number? max-change)
                                             (< max-change (* min-sum 0.95)))
                                      (fu/round (* min-sum 0.75) 0)
                                      0))
                   :lineColor     (theme/color [:chart :y-axis :line])
                   :gridLineColor (theme/color [:chart :y-axis :grid-line])}]
     :series      [{:data dt}]}))
